import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface Member {
  id: string;
  email: string;
  name: string;
  role: string;
  account_id: string | null;
  has_key: boolean;
  status: "active" | "pending" | "revoked";
  created_at: string;
  entitlements: string[];
}

export function useMembers() {
  const query = useQuery({
    queryKey: queryKeys.members.list(),
    queryFn: () => api<Member[]>("/api/v2/members"),
  });

  const refetch = useCallback(() => {
    void query.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.refetch]);

  return {
    members: query.data ?? [],
    loading: query.isLoading,
    error: query.error ? "Failed to load members" : "",
    refetch,
  };
}
